import { createSelector } from '@reduxjs/toolkit';
import { initialState } from '.';

// First select the relevant part from the state
const currentState = state => state.preRouting || initialState;

export const selectLoading = createSelector(
  [currentState],
  preRoutingState => preRoutingState.loading,
);

export const selectIsAppInstalled = createSelector(
  [currentState],
  preRoutingState => !!preRoutingState.relatedApps?.length,
);

export const selectDownloadLink = createSelector(
  [currentState],
  preRoutingState => preRoutingState.downloadLink,
);

export const selectAppsInstalled = createSelector(
  [currentState],
  preRoutingState => preRoutingState.relatedApps,
);

export const selectLatestVersion = createSelector(
  [currentState],
  preRoutingState => preRoutingState.latestVersion,
);

export const selectLatestVersionLoading = createSelector(
  [currentState],
  preRoutingState => preRoutingState.latestVersionLoading,
);
